import React from 'react';

const AudioWaveVisualizer = ({ isRecording, audioLevel }) => {
  if (!isRecording) return null;

  const bars = [];
  const numBars = 5; // Fewer bars for inside the input

  for (let i = 0; i < numBars; i++) {
    // Calculate height based on audio level
    const height = 4 + audioLevel * 12;

    bars.push(
      <div
        key={i}
        className="bg-red-500 rounded-full mx-0.5"
        style={{
          height: `${height}px`,
          width: '2px',
          animation: `pulse-${i % 3} 0.8s infinite`,
        }}
      />
    );
  }

  return (
    <div className="flex items-end h-6 mx-2">
      {bars}
    </div>
  );
};

export default AudioWaveVisualizer;